export default __webpack_public_path__ + "static/media/ConfiguracaoIcon.9ea04d85.svg";